module.exports = __webpack_public_path__ + "c34990de00abb4736345bf19fc6b73c5.png";